import type {SVGProps} from 'react'
const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" {...props}>
    <path d="M66.07 477.3a7.96 7.96 0 0 1-2.048-5.344 7.94 7.94 0 0 1 2.642-5.938L300.2 256 66.66 45.93c-3.283-2.906-3.58-8-.594-11.28 2.97-3.281 8.019-3.563 11.32-.594l240.1 216c3.345 3 3.345 8.875 0 11.88L77.38 477.9c-3.3 3-8.34 2.7-11.31-.6" />
  </svg>
)
export default SvgChevronRight
